import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledSimpleLoader from 'components/molecules/Loaders/SimpleLoader/SimpleLoader.styles';
import CircularProgress from 'components/atoms/Progress/CircularProgress/CircularProgress';
import Typography from 'components/atoms/Text/Typography/Typography';
import utils from 'helpers/utils';
import constants from 'helpers/constants';

const SimpleLoader = (props) => {
  const {
    titles,
    timeout,
    progressProps,
    ...innerProps
  } = useComponentProps({
    timeout: constants.delay.long,
    ...props
  }, 'SimpleLoader', {children: ['progress', 'title']});

  const [titleIdx, setTitleIdx] = useState(0);

  const titleCount = titles?.length ?? 0;
  useEffect(() => {
    if (timeout && (titleIdx + 1) < titleCount) {
      return utils.observeTimeout(() => {
        setTitleIdx(titleIdx + 1);
      }, timeout);
    }
  }, [titleCount, titleIdx, timeout]);

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledSimpleLoader {...innerProps}>
    <CircularProgress className="SimpleLoader-progress" {...progressProps}></CircularProgress>
    {titles?.[titleIdx] ? <Typography className="SimpleLoader-title">{titles?.[titleIdx]}</Typography> : null}
  </StyledSimpleLoader>
};

SimpleLoader.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  titles: PropTypes.array,
  progressProps: PropTypes.object
};

export default SimpleLoader;
